import { render } from "./Problems.vue?vue&type=template&id=ebf06ab6&scoped=true&ts=true"
import script from "./Problems.vue?vue&type=script&lang=ts"
export * from "./Problems.vue?vue&type=script&lang=ts"

import "./Problems.vue?vue&type=style&index=0&id=ebf06ab6&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebf06ab6"]])

export default __exports__